import { createContext, useContext, useEffect, useRef, useState } from "react";
import { ReportingContext } from "../home/home";
import { useParams } from "react-router-dom";
import { useStore } from "../../hooks-store/store";
import { getReportingLinks } from "./links";
import { sendCallToAPI, reOrderReporting } from "../../common/generic_functions";
import { LoadingScreen } from "../../components_new/loadingspinner/loading-screen";
import {DashboardCardList} from "./components/dashboard-card-list"
import { ModalWorkSpaceTags } from "./components/tags-component";
import { LabelGroups } from "./components/label-components";
import { DashboardFilter } from "./components/dashboard-filters";
import { CreateDashboard } from "../../components_new/create-dashboard/create-dashboard";
import { AlertMessage } from "../../components_new/alerts/alert-message";
import { renameWorkSpaceTag, getWorkSpaceTags, deleteWorkSpaceTag, addWorkSpaceTag } from "./components/tags-api-functions";
import { AlertContext } from "../login/login";
import "./dashboard-list.sass";




const DashboardContext = createContext();

let alertsId = 0;

export const DashboardList = () => {
  const { setCurrentWorkSpace, setCurrentWorkSpaceName, changeDesignObject, setReportingConfig, setWorkSpacePermissions, getFavReports } = useContext(ReportingContext);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [dataObject, setDataObject] = useState({ tagName: [], tagColor: [], deleteWorkTag: [], newName: [] });
  const [optionsWorksTag, setOptionsWorkstag] = useState([]);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const reportings = useRef();
  const [store] = useStore();
  const [filteredReportings, setFilteredReportings] = useState([]);
  const [listFilterTagsReport, setFilterTagsReport] = useState([]);
  const [tagsChanges, setTagChanges] = useState([]);
   const [alerts, setAlerts] = useState([]);
   const removedAlerts = useRef(new Set());

  const { workspaceId } = useParams();
  useEffect(() => {
    setCurrentWorkSpace(workspaceId ?? "");
    loadReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceId, tagsChanges]);


  //Load all the Power BI reports
  const loadReports = async () => {
    setLoading(true);
    if (workspaceId === "test-workspace-1") {
      changeDesignObject({ component: "SHIP" });
    } else {
      changeDesignObject();
    }
    const link = `${getReportingLinks("getReportsFromWS")}${workspaceId}/`;
    

    let res = await sendCallToAPI(link, store.accessToken);
    let reports = res?.reports ?? [];
    setCurrentWorkSpaceName(res?.workspace ?? null);
    setWorkSpacePermissions(res?.workspace_permissions ?? null)
    if (Array.isArray(reports) && reports.length > +0) {
      reports = reports.map((x) => {
        x.link = `./${x.id}`;
        return x;
      });
    }
   
    //Fetching all work space tags for this specific workspace id
    await getWorkSpaceTags(setOptionsWorkstag, workspaceId, store, enableAlert)  
    try {
    reportings.current = reports;
    setReportingConfig(reportings);
      let sortedReports = reOrderReporting(getFavReports(), reportings?.current ?? [])
      setFilteredReportings(sortedReports);
    } catch {
          
    } finally {
      setLoading(false);
    }
  };


  const enableAlert = ({type = "success", text = "", time = 1000, navigateHome = false, darkerVersion = false}) => {
        let al = alerts;
        const temp = {alertText: text, alertVariant: type, time: time, id: alertsId++, darkerVersion: darkerVersion};
        al = al.filter((x) => !removedAlerts.current.delete(x.id) && x.alertVariant !== temp.alertVariant && x.alertText !== temp.alertText);
        al.push(temp);
        setAlerts(() => [...al]);
    };

    const removeAlert = (id) => {
      setAlerts([])
        removedAlerts.current.add(id);
    };


  return (
    <DashboardContext.Provider value={{ listFilterTagsReport, setFilterTagsReport, setFilteredReportings, reportings: reportings?.current ?? [] }}>
      <LoadingScreen loading={loading}>
        <AlertContext.Provider value={{enableAlert, alerts: alerts, removeAlert}}>
                <AlertMessage/>
          <ModalWorkSpaceTags
            showModal={showModal}
            setShowModal={setShowModal}
            dataObject={dataObject}
            setDataObject={setDataObject}
            addWorkSpaceTag={() => addWorkSpaceTag(setLoading, dataObject, setOptionsWorkstag, workspaceId, store, enableAlert)}
            deleteWorkSpaceTag={() => deleteWorkSpaceTag(setLoading, dataObject, setTagChanges, setOptionsWorkstag, workspaceId, store, enableAlert)}
            renameWorkSpaceTag={() => renameWorkSpaceTag(setLoading, dataObject, setOptionsWorkstag, workspaceId, store, enableAlert)}
            optionsWorksTag={optionsWorksTag} />

        <div className="page-container">
          {/*  Left Container - Contains tags and filter */}
          <div className="left" style={{ backgroundColor: "white" }}>
            <LabelGroups optionsWorksTag={optionsWorksTag} showModal={showModal} DashboardContext={DashboardContext} setShowModal={setShowModal} />
          </div>

          {/*  Right Container - Contains Top-Container and Repors-Card-List,
          (Top-Conatiner conatins nav bar, menu bar, add reports and filter function) */}
   
          <div className="right" >
            {/* Top-Conatiner conatins nav bar, menu bar, add reports and filter function */}
            <div className="top">
              <div className="filter">
                <DashboardFilter DashboardContext={DashboardContext} />
              </div>
              <div className="buttonsgroup">
                <CreateDashboard />
              </div>
            </div>

            {/* Reports-Card-Container contains all the power bi reports card list */}
            <div className="list">
              <DashboardCardList
                setShowSuccessAlert={setShowSuccessAlert}
                setLoading={setLoading}
                reportings={filteredReportings}
                loadReports={loadReports}
                optionsWorksTag={optionsWorksTag} />
            </div>
          </div>
        </div>
          </AlertContext.Provider>
      </LoadingScreen>
    </DashboardContext.Provider>
  );
};
